import { useEffect, useMemo, useState } from "react";

import {
	Checkbox,
	ListItemIcon,
	MenuItem,
	TextField,
	Typography,
} from "@material-ui/core";

import { useArchiveContext } from "../../context/archive.context";
import _ from "lodash";

const initState = [
	{
		value: "All",
		queryParam: null,
		valueArabic: "الكل",
		checked: true,
	},
	{
		value: "Articles",
		queryParam: "article",
		valueArabic: "مقالات",

		checked: false,
	},
	{
		value: "Video",
		queryParam: "video",
		valueArabic: "فيديو",
		checked: false,
	},
];

export const Select = () => {
	const { lang, prTypes, selectQueryParams } = useArchiveContext();

	const [values, setValues] = useState(() => {
		if (!lang.toLowerCase() === "ar") return initState;

		const arabicVer = _.map(initState, (i) => ({ ...i, value: i.valueArabic }));

		return arabicVer;
	});

	const contentType = useMemo(() => {
		const cheked = values.find((item) => item.checked === true);
		return cheked.value;
	}, [values]);

	function handleChange(e) {
		const selectedValue = e.target.value;
		let selectedObj = null;
		const formatedItems = values.map((item) => {
			item.checked = false;

			if (item.value == selectedValue) {
				item.checked = true;
				selectedObj = item;
			}

			return item;
		});

		setValues(formatedItems);

		selectQueryParams({ prType: selectedObj.queryParam });
	}

	useEffect(() => {
		if (prTypes) {
			setValues([
				{
					value: lang.toLowerCase() === "ar" ? "الكل" : "All",
					queryParam: null,
					checked: true,
				},
				{
					value: lang.toLowerCase() === "ar" ? "مقالات" : "Articles",
					queryParam: prTypes.article.id,
					checked: false,
				},
				{
					value: lang.toLowerCase() === "ar" ? "فيديو" : "Video",
					queryParam: prTypes.video.id,
					checked: false,
				},
			]);
		}
	}, [prTypes]);

	return (
		<div className="input-types">
			<TextField
				select
				value={contentType || "all"}
				InputProps={{ disableUnderline: true }}
				onChange={handleChange}
			>
				{values.map((item) => (
					<MenuItem value={item.value} key={item.value} selected={true}>
						<ListItemIcon>
							<Checkbox fontSize="small" checked={item.checked} />
						</ListItemIcon>
						<Typography variant="inherit" style={{[lang.toLowerCase()==='ar'? "marginRight" : 'marginLeft']:14}}>{item.value}</Typography>
					</MenuItem>
				))}
			</TextField>
		</div>
	);
};
